import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lk-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.scss']
})
export class FrontPageComponent implements OnInit {
  public publication;
  public articles;
  public covers;
  public users;
  public theme;
  public cover;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data
      .map( data => {
        return {
          publication: data.data[0],
          articles: data.data[1],
          users: data.data[2],
          covers: data.data[3].filter( cover => {
            if(cover.theme_data && typeof cover.theme_data !== 'object' )
              cover.theme_data = JSON.parse(cover.theme_data);

            return cover.jpg_image_file_name
          })
        };
      })
      .subscribe(
        ( data ) => {
          this.publication = data.publication;
          this.articles = data.articles;
          this.covers = data.covers;
          this.users = data.users;
          //console.log(this.cover);
          console.log(this.users);
        }
      );

    this.route
      .queryParams
      .subscribe(
        data => {
          if(data.theme){
            const cover = this.covers.find(cover => cover.id == data.theme );
            if(cover)
              this.cover = cover;
          }
        }
      )
  }

}



// WEBPACK FOOTER //
// ./src/app/components/front-page/front-page.component.ts